import { render } from "./HomeUpcomingEvents.vue?vue&type=template&id=4dab203c"
import script from "./HomeUpcomingEvents.vue?vue&type=script&lang=js"
export * from "./HomeUpcomingEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__